import React from 'react';
import BrandPage from './BrandPage';

const EmeraldPage = () => <BrandPage brandSlug="emerald" />;

export default EmeraldPage;
